export default __webpack_public_path__ + "static/sp-divider-7bc2886b22436d966d89f55389b9ed39.png";